<section class="mt-4 px-3">
  <div class="container-fluid">
    @if (!isCargoWallet) {
      <h1 class="heading-wallet mb-3" i18n="@@wallet-activation-thankyou">
        CargoWallet Management
      </h1>
    }
    <div class="wallet-thankyou">
      <p i18n="@@wallet-activation-thankyou">
        Your request hos been successfully sent to our customer service. We will
        get back to you by email shortly.
      </p>
    </div>
  </div>
</section>
